module.exports = "<div fxFlexFill fxLayoutAlign=\"center center\" class=\"icon-pointer\">\n  <mat-icon>edit</mat-icon>\n</div>"